import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Globe } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

const languages = [
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
];

export default function LanguageSwitcher() {
  const { locale, setLocale } = useLanguage();
  const [isHovered, setIsHovered] = useState(false);

  const changeLanguage = (langCode) => {
    console.log('Changing language to:', langCode);
    setLocale(langCode);
    
    // NEU: Erzwinge Reload der Seite
    window.location.reload();
  };

  const getCurrentLanguage = () => {
    return languages.find(lang => lang.code === locale) || languages[0];
  };

  return (
    <Dropdown drop="up">
      <Dropdown.Toggle 
        as="button"
        className="d-flex align-items-center gap-3 w-100 rounded px-3 py-2"
        style={{
          backgroundColor: isHovered ? "rgba(0,0,0,0.1)" : "rgba(0,0,0,0.05)",
          color: "#333",
          border: "none",
          cursor: "pointer",
          transition: "background-color 0.2s ease",
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Globe size={22} />
        <span>{getCurrentLanguage().flag} {getCurrentLanguage().name}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {languages.map((lang) => (
          <Dropdown.Item
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            active={locale === lang.code}
          >
            <span style={{ marginRight: '8px' }}>{lang.flag}</span>
            {lang.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
